import * as React from 'react';
import { SiteContext } from '../context/SiteContext';

export const useSiteContext = () => {
  return React.useContext(SiteContext);
};
